import styled, { css } from "styled-components";

interface ModalContainerProps {
  loading: boolean;
}

export const ModalContainer = styled.div<ModalContainerProps>`
  display: flex;
  flex-direction: column;
  min-height: 10rem;

  ${(props) =>
    props.loading &&
    css`
      align-items: center;
      justify-content: center;
    `};
`;

export const ButtonAlign = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
`;
